import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { HTTP } from "../../api/resources";
export default function DonationsEdit({donation: donationProps, creating_new = null}) {
  const [donation, setDonation] = useState(null);
  const [saving, setSaving] = useState(false);
  const newItem = creating_new

  useEffect(() => {
    if (!donation) {
      setDonation({
        ...donationProps,
        unit_cost: parseFloat(donationProps.unit_cost).toFixed(2)
      });
    }
  }, [donation, donationProps]);

  if (!donation) {
    // Some loading state
    return <></>;
  }

  const handleSubmit = () => {
    // validations
    if (donation.name.length == 0 || donation.description.length == 0 || donation.unit_cost < 1) {
      Alert.show("error", "All fields are required.");
      return;
    }

    if (donation.unit_cost == null || donation.unit_cost == "NaN" || donation.unit_cost < 1) {
      Alert.show('error', 'Unit Cost is a required field')
      return;
    }

    setSaving(true)
    {HTTP.patch(`/donations/${donation.id}`, {
      donation: donation
    }).then(response => {
      Alert.show("notice", "Donation Item Saved!");
      setDonation(response.data);

      setSaving(false);
      setTimeout(() => {window.location = '/donations'}, 1500)
    }).catch(e => {
      Alert.show("error", "Could not save. Try again or refresh.");
      setSaving(false);
    })}
  }

  const handleCreate = async () => {
    // validations
    if (donation.name.length == 0 || donation.description.length == 0 || donation.unit_cost < 1) {
      Alert.show("error", "All fields are required.");
      return;
    }

    if (donation.unit_cost == null || donation.unit_cost == "NaN" || donation.unit_cost < 1) {
      Alert.show('error', 'Unit Cost is a required field')
      return;
    }

    try {
      await createNewItem(donation)
    } catch {
      Alert.show('error', 'Could not save donation item, try again')
      return;
    }

    Alert.show("notice", "Donation Item Saved!");
    setTimeout(() => {window.location = '/donations'}, 1500)
  }

  const createNewItem = (data) => {
    return HTTP.post('/donations/new', data)
  }

  return (
    <React.Fragment>
      <div className="page-header d-flex align-items-baseline">
        <h4 className="">
          <a href="/donations">
            <i className="fa fa-chevron-left mr-2"></i> Back
          </a>
        </h4>
        <ul className="breadcrumbs">
          <li className="nav-item">
            Donation Items
          </li>

          <li className="separator">
            <i className="fa fa-arrow-right"></i>
          </li>
          <li className="nav-item">
            {donation.name}
          </li>
        </ul>
      </div>
      <div className="card">
        <div className="card-header flex-header">
          <h4 className="card-title">
            Donation Item Editor
          </h4>

          <div>
            {!newItem &&
              <button onClick={handleSubmit} name="button" className="btn btn-primary">
              {saving && <i className="fa fa-spinner-third fa-spin mr-2"></i>}
              Save
            </button>}
            {newItem &&
              <button onClick={handleCreate} name="button" className="btn btn-primary">
                {saving && <i className="fa fa-spinner-third fa-spin mr-2"></i>}
                Create
              </button>
            }
          </div>
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor="name">Name</label>
                <input className="form-control" placeholder="New Donation Item" type="text" name="name" id="name"
                  value={donation.name}
                  onChange={e => {
                    const val = e.target.value;
                    setDonation(donation => {
                      return { ...donation, name: val }
                    });
                  }}
                  disabled={donation.locked}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor="description">Description</label>
                <input className="form-control" placeholder="Description" type="text" name="description" id="description"
                  value={donation.description}
                  onChange={e => {
                    const val = e.target.value;
                    setDonation(donation => {
                      return { ...donation, description: val }
                    });
                  }}
                  disabled={donation.locked}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor="unit_cost">Unit Cost</label>
                <input className="form-control" placeholder="0.00" type="number" step="0.01" name="unit_cost" id="unit_cost"
                  value={donation.unit_cost}
                  onChange={e => {
                    const val = e.target.value;
                    setDonation(donation => {
                      return { ...donation, unit_cost: val }
                    });
                  }}
                  onBlur={e => {
                    const val = parseFloat(donation.unit_cost).toFixed(2)
                    setDonation(donation => {
                      return { ...donation, unit_cost: val}
                    })
                  }}
                  disabled={donation.stripe_product_id || donation.stripe_price_id || donation.locked}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor="unit_cost">Currency</label>
                <div>
                  <select
                    class="form-control"
                    value={donation.currency}
                    onChange={e => {
                      const val = e.target.value;
                      setDonation(donation => {
                        return { ...donation, currency: val }
                      });
                    }}
                    disabled={donation.stripe_product_id || donation.stripe_price_id || donation.locked}
                  >
                      <option value="USD">USD - United States Dollar</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

DonationsEdit.propTypes = {
  donation: PropTypes.object
};
